import { render } from "./SelectIntestatario.vue?vue&type=template&id=3c86cab4"
import script from "./SelectIntestatario.vue?vue&type=script&lang=js"
export * from "./SelectIntestatario.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__